<template>
  <div :class="classes">pt-order-new</div>
</template>

<script>
// 组件class前缀
const prefixCls = 'pt-order-new'

export default {
  name: 'pt-order-new',
  computed: {
    classes () {
      return `${prefixCls}`
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */

</style>
